import { TokenStorage } from "./TokenStorage";
import { browserFetch } from "../api/BrowserFetch";
import type { TokenPair } from "./TokenStorage";

let inFlight: Promise<boolean> | null = null;

/**
 * Exchanges the stored refresh token for a fresh token pair.
 * Concurrent callers share a single in-flight request. Returns false (and clears
 * tokens) when no refresh token is present or the refresh is rejected.
 */
export function refreshTokens(): Promise<boolean> {
  let refreshTokensOutcome: Promise<boolean>;
  if (inFlight) {
    refreshTokensOutcome = inFlight;
  } else {
    inFlight = doRefresh().finally(() => {
      inFlight = null;
    });
    refreshTokensOutcome = inFlight;
  }
  return refreshTokensOutcome;
}

async function doRefresh(): Promise<boolean> {
  let doRefreshOutcome: boolean;
  const refreshToken = TokenStorage.getRefreshToken();
  if (refreshToken === null) {
    doRefreshOutcome = false;
  } else {
    const response = await browserFetch("/api/auth/refresh", {
      method: "POST",
      headers: { "auth-token": refreshToken },
    });
    if (!response.ok) {
      TokenStorage.clearTokens();
      doRefreshOutcome = false;
    } else {
      const tokens = (await response.json()) as TokenPair;
      TokenStorage.setTokens(tokens);
      doRefreshOutcome = true;
    }
  }
  return doRefreshOutcome;
}
